import React from 'react';
import ServicesHero from '../components/services/ServicesHero';
import ServicesGrid from '../components/services/ServicesGrid';
import ServicesProcess from '../components/services/ServicesProcess';
import ServicesCTA from '../components/services/ServicesCTA';

const Services = () => {
  return (
    <div>
      <ServicesHero />
      <ServicesGrid />
      {/* <ServicesProcess /> */}
      <ServicesCTA />
    </div>
  );
};

export default Services;